import React from 'react';
export function ProblemSection() {
  return <section className="bg-muted py-16 sm:py-24" data-id="element-509">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-510">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-511">
          {/* Left: Image */}
          <div className="flex justify-center lg:justify-start order-2 lg:order-1" data-id="element-512">
            <div className="w-full max-w-sm aspect-[4/5] rounded-2xl overflow-hidden border border-green-200 shadow-md" data-id="element-513">
              <img src="https://cdn.magicpatterns.com/uploads/917HpMZRr4WrrjyBcLGX1c/ChatGPT_Image_Feb_27,_2026,_08_41_53_PM.png" alt="Mujer antes de Trimora" className="w-full h-full object-cover" unselectable="on" data-id="element-514" />
            </div>
          </div>

          {/* Right: Text */}
          <div className="flex flex-col gap-6 order-1 lg:order-2" data-id="element-515">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground leading-tight" data-id="element-516">
              ¿Te Suena Familiar?
            </h2>

            <div className="flex flex-col gap-4 text-muted-foreground text-lg leading-relaxed" data-id="element-517">
              <p data-id="element-518">
                Comes mejor que antes. Intentas moverte más. Pero el abdomen no
                cambia.
              </p>
              <p data-id="element-519">Después de los 30–40, el cuerpo responde distinto.</p>
              <p className="text-foreground font-medium" data-id="element-520">
                No es falta de disciplina. Es biología.
              </p>
              <p data-id="element-521">
                El metabolismo cambia. Las señales de hambre cambian. La energía
                cambia.
              </p>
            </div>

            <div className="bg-background rounded-xl p-5 border border-border" data-id="element-522">
              <p className="text-sm text-muted-foreground italic" data-id="element-523">
                "Muchas mujeres y hombres mayores de 35 experimentan cambios
                metabólicos naturales que dificultan el control del peso,
                independientemente de sus hábitos."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}